import setChangeColorButtonHandler from "../include/setChangeColorButtonHandler";

$(function () {
    const COLOR_BUTTON_SELECTOR = '.jsCompareColorButton';

    /** изменение цвета сравнения */
    setChangeColorButtonHandler(
        '#jsCompareColorImage',
        COLOR_BUTTON_SELECTOR,
        '#jsCompareColorName'
    );

    const SLIDER_SELECTOR = '#jsCompareSliderContainer';
    const IMAGE_CONTAINER_SELECTOR = '#jsCompareColorContainer';
    const WORK_AREA_SELECTOR = '#carImageContainer';

    let sliderOffset;
    let imageContainerWidth;

    /** анимация блока нового цвета */
    $(document).on('changeColorImageOnload', function (e, data) {
        if (data.$target.hasClass(COLOR_BUTTON_SELECTOR.slice(1))) {
            let $slider = $(SLIDER_SELECTOR);
            let $imageContainer = $(IMAGE_CONTAINER_SELECTOR);
            $slider.css({left: '100%'}).show();
            $imageContainer.css({width: '100%'}).show();
            sliderOffset = $slider.width() / 2;
            let oldWith = getContainerWith();
            $imageContainer.find('img').width(oldWith);
            let width = (oldWith / 2);
            $imageContainer.animate({'width': width}, 512);
            $slider.animate({'left': width}, 512);
        }
    });

    $(window).on('resize', function () {
        $(IMAGE_CONTAINER_SELECTOR)
            .find('img')
            .width(
                $(WORK_AREA_SELECTOR).find('img').width()
            );
    });

    /** слайдер */
    $(document).on('mousedown', SLIDER_SELECTOR, slideStart);
    $(document).on('touchstart', SLIDER_SELECTOR, slideStart);
    $(document).on('mousemove', WORK_AREA_SELECTOR, slide);
    $(document).on('touchmove', WORK_AREA_SELECTOR, slide);
    $(document).on('mouseup', slideStop);
    $(document).on('touchstop', slideStop);

    let clicked = false;

    function slideStart() {
        clicked = true;
    }

    function slideStop() {
        clicked = false;
    }

    function slide(e) {
        if (clicked === false) return;
        let $imageContainer = $(IMAGE_CONTAINER_SELECTOR);
        let width = e.changedTouches ? e.changedTouches[0] : e;
        width = width.clientX - $imageContainer.offset().left;

        let max = getContainerWith();
        if (width < 0) {
            width = 0;
        }
        if (width > max) {
            width = max;
        }

        $imageContainer.width(width);
        $(SLIDER_SELECTOR).css({left: width});
    }

    function getContainerWith() {
        if (!imageContainerWidth) {
            imageContainerWidth = $(IMAGE_CONTAINER_SELECTOR).width();
        }
        return imageContainerWidth;
    }

    let COMPARE_BUTTON_SELECTOR = '#jsCompareColorToggleButton';
    let COLOR_CONTAINER_SELECTOR = '#jsCompareColorToggleContainer';
    let STUFF_SELECTOR = '.label-color-suf';
    /** показать блок сравнения цветов */
    $(document).on('click', COMPARE_BUTTON_SELECTOR, function () {
        $(this).toggleClass('active');
        $(COLOR_CONTAINER_SELECTOR).toggle();
        $(SLIDER_SELECTOR).hide();
        $(IMAGE_CONTAINER_SELECTOR).hide();
        $(STUFF_SELECTOR).toggleClass('hidden');
    })
});